
// Used through the app to help string manipulations

// METHODS
// ---- Capitalize first letter of a text
export function capitalizeFirst(text) {
    return text.charAt(0).toUpperCase() + text.slice(1);
}

// ---- Trim trailing zeros in numbers as string
export function trimTrailingZerosInDecimals(input) {
    // Defense
    if (!input.includes(',')) {
        return input; // pas de décimales
    }

    // Split int and decimal parts
    const [intPart, decPart] = input.split(',');

    // Clean decimal part
    const cleaned = decPart.replace(/0+$/, '');

    // Rebuild decimal number if cleaned
    return cleaned !== '' ? `${intPart},${cleaned}` : intPart;
}

// ---- Create html indented list from a bullet text with "-" markers
export function renderBulletText(text) {
    const lines = String(text).replace(/\r\n?/g, "\n").split("\n");
    const nodes = [];
    let listBuffer = [];
    let key = 0;

    const bulletRE = /^\s*[-*•–—]\s+/; // tolère indentation + plusieurs symboles

    const flushList = () => {
        if (listBuffer.length) {
            nodes.push(
                <ul
                    key={`ul-${key++}`}
                    className="list-disc list-outside pl-[14px] my-[2px] space-y-[1px]"
                >
                    {listBuffer}
                </ul>
            );
            listBuffer = [];
        }
    };

    for (const raw of lines) {
        const line = raw ?? "";
        const trimmed = line.trim();

        // ligne vide = séparation de blocs
        if (trimmed.length === 0) {
            flushList();
            continue;
        }

        if (bulletRE.test(line)) {
            const content = line.replace(bulletRE, "").trim();
            listBuffer.push(<li key={`li-${key++}`}>{content}</li>);
        } else {
            flushList();
            nodes.push(
                <p key={`p-${key++}`} className="my-2 leading-relaxed">
                    {trimmed}
                </p>
            );
        }
    }

    flushList();
    return nodes;
}

// export function aboutScreenHighlightWords(text, highlights) {
//     if (!text) return text;
//
//     // convertit juste les apostrophes non-ASCII
//     const asciiText = forceAsciiApostrophe(text);
//     const asciiHighlights = highlights.map(forceAsciiApostrophe);
//
//     const escapedHighlights = asciiHighlights.map(escapeRegExp);
//     const regex = new RegExp(`(${escapedHighlights.join("|")})`, "gi");
//     const parts = asciiText.split(regex);
//
//     return parts.map((part, i) => {
//         const isHighlight = asciiHighlights.some(
//             h => h.toLowerCase().trim() === part.toLowerCase().trim()
//         );
//
//         return isHighlight ? (
//             <span key={i} className="text-white font-semibold">
//                 {part}
//             </span>
//         ) : (
//             part
//         );
//     });
// }

export function aboutScreenHighlightWords(text, highlights) {
    if (!text) return text;

    // convertit juste les apostrophes non-ASCII
    const asciiText = forceAsciiApostrophe(text);
    const asciiHighlights = highlights.map(forceAsciiApostrophe);

    const escapedHighlights = asciiHighlights.map(escapeRegExp);
    const regex = new RegExp(`(${escapedHighlights.join("|")})`, "gi");
    const parts = asciiText.split(regex);

    return parts.map((part, i) => {
        const isHighlight = asciiHighlights.some(
            h => h.toLowerCase().trim() === part.toLowerCase().trim()
        );

        // ⚡️ Si le texte contient du HTML (comme <sup>), on le rend proprement
        if (isHighlight) {
            return (
                <span
                    key={i}
                    className="text-white font-semibold"
                    dangerouslySetInnerHTML={{ __html: part }}
                />
            );
        } else {
            return <span key={i} dangerouslySetInnerHTML={{ __html: part }} />;
        }
    });
}

function forceAsciiApostrophe(str) {
    return str.replace(/[\u2018\u2019\u201B\u2032]/g, "'"); // remplace seulement les apostrophes “typographiques”
}

function escapeRegExp(str) {
    return str.replace(/[.*+?^${}()|[\]\\]/g, "\\$&");
}


